import { render, staticRenderFns } from "./study-demo.vue?vue&type=template&id=af040162&scoped=true&"
import script from "./study-demo.vue?vue&type=script&lang=js&"
export * from "./study-demo.vue?vue&type=script&lang=js&"
import style0 from "./study-demo.vue?vue&type=style&index=0&id=af040162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af040162",
  null
  
)

export default component.exports